import { Input } from '@chakra-ui/react';
import { FormikHelpers } from 'formik';
import { forwardRef, Ref } from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';

import { BookingFlowState } from '@/components/context/BookingFlowProvider';
import 'react-datepicker/dist/react-datepicker.css';

const DatepickerCustomInput = forwardRef(
  (
    {
      children,
      onClick,
      ...rest
    }: { children?: React.ReactNode; onClick?: () => void },
    ref: Ref<HTMLInputElement>,
  ) => (
    <Input
      ref={ref}
      type="text"
      placeholder="Autocomplete TODO"
      onClick={onClick}
      {...rest}>
      {children}
    </Input>
  ),
);

export default function GoShipDatepicker({
  name,
  value,
  setFieldValue,
  setFieldTouched,
  popperPlacement,
  includeDates,
}: {
  name: string;
  value: Date | null;
  setFieldValue: FormikHelpers<BookingFlowState>['setFieldValue'];
  setFieldTouched: FormikHelpers<BookingFlowState>['setFieldTouched'];
  popperPlacement: ReactDatePickerProps['popperPlacement'];
  includeDates: Date[];
}) {
  return (
    <DatePicker
      name={name}
      selected={value}
      onChange={date => setFieldValue(name, date)}
      onBlur={() => setFieldTouched(name, true)}
      customInput={<DatepickerCustomInput />}
      popperPlacement={popperPlacement}
      includeDates={includeDates}
    />
  );
}
